<template>
  <div class="bg-light-gray overflow-x-hidden">
    <div class="d-none d-md-block">
      <ResultsNav :initialValue="values.described_item" @search="handleSearch($event)"/>
    </div>
    <template v-if="nav === 1" :class="{ 'bottom-nav-spacing': $vuetify.breakpoint.smAndDown }">
      <template v-if="$vuetify.breakpoint.mdAndUp"><br><br></template>
      <v-card class="py-6 position-relative overflow-hidden px-0 d-block d-md-none" rounded="0" outlined>
        <div class="container pa-5 pa-md-6 text-left overflow-hidden">
          <div class="banner-title text-h2 black--text font-weight-bold pr-5 d-flex align-center">
            {{ items.length }}
            <div class="body-1 black--text ml-3">Items</div>
          </div>
        </div>
        <div class="absolute right top" style="transform: translate(40%, 10px); opacity: .7">
          <img src="/img/instagram-phone-half.png" alt="ig phone"/>
        </div>
      </v-card>
      <div class="container px-0 py-md-8 bottom-nav-spacing" style="max-width: 900px;">
        <v-row>
          <v-col cols="12" md="9">
            <v-row dense>
              <v-col v-for="item in items" :key="item.id" class="px-md-2 pb-0" cols="12" sm="6">
                <ItemCardMerchant :value="item" @select="handleSelect(item)" @request="views.call = true;"/>
              </v-col>
            </v-row>
            <v-row v-if="loading" dense>
              <v-col v-for="i in 4" :key="i" class="px-2 pb-0 mb-3" cols="12" sm="6">
                <ItemCardLoading/>
              </v-col>
            </v-row>
            <div v-if="!pagination.end && !loading" class="my-12 d-flex justify-center">
              <v-btn @click="loadMore()" outlined>Load more</v-btn>
            </div>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="12" md="3">
            <div style="position: sticky; top: 100px;" class="mt-6">
              <div class="banner-title font-weight-medium" style="font-size: 4rem; line-height: 1; color: #162c5d">
                {{ items.length }} <br> items
              </div>
              <div class="d-flex flex-column mt-8">
                <div class="mt-8">
                  <div
                    v-for="c in categories.slice(0, 5)" :key="c.id"
                    @click="handleCategoryClick(c)"
                    class="desktop-link active cursor-pointer"
                  >
                    {{ c.name }}
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>

    <SpeedDial/>

    <StandaloneBottomNav/>

    <v-dialog
      v-if="$vuetify.breakpoint.smAndDown" v-model="details.visible"
      fullscreen hide-overlay transition="dialog-bottom-transition"
    >
      <QuickAddToCart v-if="details.item" :value="details.item" @close="details.visible = false"/>
    </v-dialog>
    <v-navigation-drawer v-else v-model="details.visible" fixed right temporary width="550">
      <QuickAddToCart v-if="details.item" :value="details.item" @close="details.visible = false"/>
    </v-navigation-drawer>

    <v-bottom-sheet
      v-if="$vuetify.breakpoint.smAndDown" v-model="views.call" max-width="500" inset persistent scrollable
    >
      <ContactSupport @close="views.call = false"/>
    </v-bottom-sheet>
    <v-navigation-drawer v-else fixed right temporary v-model="views.call" width="550">
      <ContactSupport @close="views.call = false"/>
    </v-navigation-drawer>
  </div>
</template>

<script>
import ItemCardMerchant from "@/components/standalone/merchants/ItemCardMerchant";
import ItemCardLoading from "@/components/templates/elements/ItemCardLoading";
import ResultsNav from "@/components/standalone/results/ResultsNav";
import StandaloneBottomNav from "@/components/standalone/StandaloneBottomNav";
import QuickAddToCart from "@/components/catalogue/QuickAddToCart.vue";
import categories from "@/lib/categories.js";
import SpeedDial from "@/components/SpeedDial.vue";
import ContactSupport from "@/components/ContactSupport.vue";

export default {
  name: "Search",
  components: {
    ContactSupport,
    SpeedDial,
    QuickAddToCart,
    StandaloneBottomNav,
    ResultsNav,
    ItemCardLoading,
    ItemCardMerchant
  },
  metaInfo() {
    return {
      title: 'Results'
    }
  },
  data() {
    return {
      items: [],
      loading: false,
      merchantsCount: 0,
      nav: 1,
      query: '',
      values: {
        described_item: '',
        minimum_amount: 0,
        maximum_amount: 0,
        category_id: null
      },
      pagination: {
        page: 1,
        end: false,
        next_cursor: null
      },
      views: {
        search: false,
        categories: false,
        call: false,
      },
      details: {
        item: null,
        visible: false
      },
      categories,
    }
  },
  watch: {
    '$route': 'handleRouteChange'
  },
  created() {
    this.handleRouteChange();
  },
  methods: {
    async handleRouteChange() {
      const { pid, q, ...rest } = this.$route.query;
      if (pid) {
        this.details.item = await this.getItem(pid);
        this.details.visible = true;
      }
      if (q !== this.values.described_item || Object.keys(rest).length) {
        this.initSearch();
      }
    },
    handleSelect(item) {
      const q = this.$route.query;
      if (q.pid && q.pid === item.slug) {
        this.details.visible = true;
        return;
      }
      this.$router.push({ query: { ...q, pid: item.slug } });
    },
    async runSearch(page) {
      this.loading = true;
      const payload = Object.keys(this.values).reduce((acc, key) => {
        if (this.values[key]) acc[key] = this.values[key];
        return acc;
      }, {});
      if (payload.described_item.includes(', ')) payload.described_item = payload.described_item.split(', ');
      const res = await this.$http.post(`/shop/web`, { ...payload, show_result: true }, {
        params: { page, next_cursor: this.pagination.next_cursor }
      });
      const { data = [], next_cursor, end } = res.data?.data?.results_data;
      this.items = page === 1 ? data : [...this.items, ...data];
      this.pagination.next_cursor = next_cursor;
      this.pagination.end = end;
      this.pagination.page = page;
      this.merchantsCount = new Set(this.items.map(item => item.merchant_slug)).size;
      this.loading = false;
    },
    loadMore() {
      const { page, end } = this.pagination;
      if (!end) this.runSearch(page + 1);
    },
    handleSearch(q) {
      this.views.search = false;
      this.$router.replace({ query: { q } });
    },
    initSearch() {
      this.values.described_item = this.$route.query?.q || '';
      this.values.category_id = this.$route.query?.category_id || '';
      this.values.minimum_amount = this.$route.query?.minimum_amount || '';
      this.values.maximum_amount = this.$route.query?.maximum_amount || '';
      this.pagination = { page: 1, end: false, next_cursor: null };
      this.items = [];
      if (this.values.category_id) this.values.described_item = this.getQueryFromCategory(this.values.category_id) || this.values.described_item;
      this.runSearch(this.pagination.page);
    },
    getQueryFromCategory(category_id) {
      return categories.find(c => `${ c.id }` === `${ category_id }`)?.keyword;
    },
    async getItem(slug) {
      const found = this.items.find(item => item.slug === slug);
      if (found) return found;
      const id = await this.$store.dispatch('catalogue/resolveItemId', slug);
      // eslint-disable-next-line no-unused-vars
      const { data: { data: { merchant, ...item } } } = await this.$http.get(`/item/${ id || slug }`);
      return item;
    },
    handleCategoryClick(category) {
      this.$router.push({ path: '/search', query: { category_id: category.id } });
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep .desktop-link {
  text-decoration: none;
  font-size: 1.3rem;
  color: #2e3c55 !important;
  opacity: .5;
  margin-bottom: 4px;

  &.active {
    opacity: 1;
  }
}
</style>
